import type { NodeDefinition } from '../../types';
import { t, r } from '../../rubyParts';
import { compareIfValues } from '../ifComparison';
import { IF_SOURCE_HANDLES } from '../ifHandles';
import { IfSettings } from '../settings/IfSettings';
import { IfNodeView } from '../views/IfNode';

export const ifDefinition: NodeDefinition<'if'> = {
  label: 'If',
  showInPalette: true,
  paletteColor: 'bg-amber-100 border-amber-500 text-amber-700',
  miniMapColor: '#f59e0b',
  defaultData: {
    label: 'If',
    operator: '=',
    compareValue: '',
  },
  view: IfNodeView,
  settings: IfSettings,
  run: (node, ctx, log) => {
    const result = compareIfValues(ctx.lastValue, node.data.operator, node.data.compareValue);
    const nextHandle = result ? IF_SOURCE_HANDLES.true : IF_SOURCE_HANDLES.false;
    const branchLabel = result ? 'true' : 'false';
    log(`[If] ${String(ctx.lastValue ?? '')} ${node.data.operator} ${node.data.compareValue} -> ${branchLabel}`);
    return { nextHandle, branchLabel };
  },
  help: {
    title: [t('If（'), r('条件', 'じょうけん'), r('分岐', 'ぶんき'), t('）')],
    description: [
      r('受', 'う'),
      t('け'),
      r('取', 'と'),
      t('った'),
      r('値', 'あたい'),
      t('と'),
      r('設定', 'せってい'),
      t('した'),
      r('値', 'あたい'),
      t('を'),
      r('比', 'くら'),
      t('べ、'),
      r('結果', 'けっか'),
      t('が'),
      r('正', 'ただ'),
      t('しければ「true」、'),
      r('違', 'ちが'),
      t('えば「false」へ'),
      r('進', 'すす'),
      t('みます。'),
    ],
  },
};
